/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedStripeTerminalReaderList } from '../models/PaginatedStripeTerminalReaderList';
import type { StripeTerminalReader } from '../models/StripeTerminalReader';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class StripeEndpoint {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any No response body
   * @throws ApiError
   */
  public stripeAccountsOauthRetrieve(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/stripe/accounts/oauth/',
    });
  }

  /**
   * @returns PaginatedStripeTerminalReaderList
   * @throws ApiError
   */
  public stripeCardTerminalsList({
    companyDrivingSchoolId,
    limit,
    offset,
  }: {
    /**
     * Filter readers by driving school id
     */
    companyDrivingSchoolId: string,
    /**
     * Number of results to return per page.
     */
    limit?: number,
    /**
     * The initial index from which to return the results.
     */
    offset?: number,
  }): CancelablePromise<PaginatedStripeTerminalReaderList> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/stripe/card-terminals/',
      query: {
        'company__driving_school_id': companyDrivingSchoolId,
        'limit': limit,
        'offset': offset,
      },
    });
  }

  /**
   * @returns StripeTerminalReader
   * @throws ApiError
   */
  public stripeCardTerminalsRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this stripe terminal reader.
     */
    id: string,
  }): CancelablePromise<StripeTerminalReader> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/stripe/card-terminals/{id}/',
      path: {
        'id': id,
      },
    });
  }

}
